import { Box, Button } from '@mui/material';
import { TimeRange } from '../../types/dashboard';

const RANGES: { label: string; value: TimeRange }[] = [
  { label: '15dk', value: '15m' },
  { label: '1s', value: '1h' },
  { label: '6s', value: '6h' },
  { label: '24s', value: '24h' },
  { label: '2g', value: '2d' },
];

interface Props {
  value: TimeRange;
  onChange: (range: TimeRange) => void;
  darkMode?: boolean;
}

const TimeRangeBar = ({ value, onChange, darkMode }: Props) => (
  <Box sx={{ display: 'flex', gap: 0.5 }}>
    {RANGES.map(r => (
      <Button
        key={r.value}
        size="small"
        variant={value === r.value ? 'contained' : 'text'}
        onClick={() => onChange(r.value)}
        sx={{
          minWidth: 0,
          px: 1.2,
          py: 0.3,
          fontSize: 11,
          color: value !== r.value ? (darkMode ? '#94a3b8' : undefined) : undefined,
        }}
      >
        {r.label}
      </Button>
    ))}
  </Box>
);

export default TimeRangeBar;
